module.exports = __webpack_public_path__ + "media/img/avatars/teams/team-logo-4-38387cc50faeb39a329a0e773a6855fe.jpg";